<h1 mat-dialog-title translate class="se-dialog-header mat-elevation-z6">
    Viewer
</h1>

<div mat-dialog-content class="se-dialog-content">
    <p translate>ViewerOpeningTimeout</p>
    <a *ngIf="isIntegrationAppConnected" [mat-dialog-close]="true" translate>ViewerOpeningRetry</a>
</div>

<div mat-dialog-actions class="se-dialog-actions">
    <button mat-button translate color="primary" [mat-dialog-close]="false">Ok</button>
</div>
